import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RunnableClass;
function Runnable() {
  if (RunnableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Runnable');
    RunnableClass = $;
  }
  return RunnableClass;
}
function Runnable$run$ref(p0) {
  return constructCallableReference(() => {
    p0.u11();
    return Unit_instance;
  }, 0, 0, 4, 'run', [p0]);
}
//region block: exports
export {
  Runnable$run$ref as Runnable$run$refpie9wh9id4g0,
  Runnable as Runnablezd7bpy5et5p0,
};
//endregion

//# sourceMappingURL=Runnable.mjs.map
